<template>
  <v-container fluid class="pa-2">
    
    <template v-if="showOld">
      <!-- FIRST SECTION 2 Columns, 2 rows in first column -->

      <div class="d-flex flex-wrap align-stretch ma-0 pa-0">
        <!-- FIRST Column -->
        <div class="col-12 col-lg-9 ma-0 pa-0 d-flex flex-wrap">
          <!-- FIRST Row -->
          <div class="col-12 ma-0 pa-2">
            <!--<m2h-best-choices></m2h-best-choices>-->
            <m2h-spotlight></m2h-spotlight>
          </div>
          <!-- SECOND Row -->
          <div class="col-12 ma-0 pa-2">
            <m2h-continue-journey></m2h-continue-journey>
          </div>

        </div>

        <!-- SECOND Column -->
        <div class="col-12 col-lg-3 ma-0 pa-2">
          <m2h-news-feed></m2h-news-feed>
        </div>

      </div>

      <!-- SECOND SECTION 1 Column -->

      <div class="d-flex flex-wrap align-stretch ma-0 pa-0">
        <!-- FIRST Column -->
        <div class="col-12 ma-0 pa-0">
          <m2h-challenges-widget></m2h-challenges-widget>
        </div>
      </div>

      <!-- THIRD SECTION 3 Columns -->

      <div class="d-flex flex-wrap align-stretch ma-0 pa-0">
        <!-- FIRST Column -->
        <div class="col-12 col-lg-3 ma-0 pa-2">
          <m2h-daily-inspiration></m2h-daily-inspiration>
        </div>

        <!-- SECOND Column -->
        <div class="col-12 col-lg-6 ma-0 pa-2">
          <m2h-upcoming-events></m2h-upcoming-events>
        </div>

        <!-- THIRD Column -->
        <div class="col-12 col-lg-3 ma-0 pa-2" v-if="!connectionWefitterLoading">
          <m2h-account-setup v-if="!connectionWefitter.wefitterBioAgeConnected"></m2h-account-setup>
          <m2h-bio-age-widget v-else-if="connectionWefitter.wefitterBioAgeConnected"></m2h-bio-age-widget>
        </div>

      </div>
    </template>

    <v-container fluid class="pa-2">
      <m2h-spotlight></m2h-spotlight>
    </v-container>
    
    <v-container fluid class="pa-2">
      <mth-bio-age-widget></mth-bio-age-widget>
    </v-container>
    
    <v-container fluid class="pa-0">
      <m2h-challenges-widget></m2h-challenges-widget>
    </v-container>

    <v-container fluid class="pa-2">
      <m2h-upcoming-events></m2h-upcoming-events>
    </v-container>

    <v-container fluid class="pa-2">
      <m2h-news-feed></m2h-news-feed>
    </v-container>

    <!-- CONSENT DIALOG -->
    <m2h-consent-dialog></m2h-consent-dialog>
    
  </v-container>
</template>

<script>

import api from "@/api/api";
import M2hBioAgeWidget from "@/page-elements/widgets/wefitter/M2hBioAgeWidget.vue";

export default {
  name: "m2h-dashboard",
  components: {M2hBioAgeWidget},
  data() {
    return {
      outline: false,
      connectionWefitterLoading: false,
      connectionWefitter: {},
      showOld: false
    }
  },

  mounted(){
    this.fetchConnectionWefitter()
  },
  
  methods: {
    async fetchConnectionWefitter() {
      const that = this
      that.connectionWefitterLoading = true
      await api.connections.getWefitterStatus()
          .then((res) => {
            that.connectionWefitter = res.data
            that.connectionWefitterLoading = false
          })
    },
  }
}
</script>

<style scoped>

</style>
